import _ from 'lodash';

const url = {
	reTrailingSlash: /\/$/,
	reIsHashOrQuerystring: /^[#/?]/,
	concat: function() {
		let concatenatedUrl = '';
		if (arguments.length) {
			let urlFragments = url.removeEmptyValuesFromArray(arguments[0] instanceof Array ? arguments[0] : arguments),
				urlFragment;
			
			for (let iArg = 0; iArg < urlFragments.length; iArg++) {
				urlFragment = urlFragments[iArg];
				urlFragment = typeof urlFragment === 'string' ? urlFragment.trim() : '';
				
				if (iArg !== urlFragments.length - 1) {
					urlFragment = urlFragment.replace(url.reTrailingSlash, '');
				}
				
				concatenatedUrl += (iArg !== 0 && !url.reIsHashOrQuerystring.test(urlFragment) && urlFragment.length > 0 ? '/' : '') + urlFragment;
			}
		}
		return concatenatedUrl;
	},
  removeEmptyValuesFromArray: function(arr) {
		let resultArr = [];
		for (let iArg = 0; iArg < arr.length; iArg++) {
			
			if (arr[iArg]) {
				resultArr.push(arr[iArg]);
			}
		}
		return resultArr;
	},
  removeProtocol(urlString) {
		return urlString.replace(/^\w+:\/\//i, '');
	}
};

const getBreakpoint = width => {

	const keys = Object.keys(BREAKPOINTS);
	const values = Object.values(BREAKPOINTS);
	let match;
  
	values.every((value, index) => {
	  if (width <= value) {
		match = keys[index];
		return false;
	  }
	  return true;
	});
  
	return match;
};

const buildHashParameter = (key, value) => {
	return value ? `/${key}=${encodeURIComponent(value)}` : ``;
};

function parseJSONWithFallback(jsonString) {
	try {
	  return JSON.parse(jsonString);
	} catch (error) {
	  console.error('Error parsing JSON:', error);
	  return {};
	}
  }

  function scrollTo(link) {
	const scrollSelector = _.find(link.dataAttributes, {key:'scrollSelector'}).value
  	const element = document.querySelector(scrollSelector)
  	if (element) {
  		element.scrollIntoView({ behavior: "smooth" })
  	}
  }

export { 
  url,
  getBreakpoint,
  buildHashParameter,
  parseJSONWithFallback,
  scrollTo
}

